// extracted by mini-css-extract-plugin
export default {"cell":"LeftColumnBody_cell__CfgH6","placeHolderShimmer":"LeftColumnBody_placeHolderShimmer__N6Kzz"};